import { NavigationContainer } from "@react-navigation/native";
import { Platform } from "react-native";
import linking from "./src/navigation/linking";
import navigationNames from "./src/navigation/navigationNames";
import RootStackNavigation from "./src/navigation/RootStackNavigation";
import * as Linking from "expo-linking";

const initialURL = async () => {
  return await Linking.getInitialURL();
};

export default function App() {
  return (
    <NavigationContainer
      linking={linking}
      // initialState={{
      //   routes: [{ name: initialURL || navigationNames.home.id }],
      // }}
    >
      <RootStackNavigation />
    </NavigationContainer>
  );
}
